import { GET_ROSS1000_STRUTTURE } from './index';

export function getRoss1000Strutture(data) {
  return {
    type: GET_ROSS1000_STRUTTURE,
    request: {
      op: 'post',
      path: `/@ross1000-strutture`,
      data: { ...data },
    },
  };
}
